import {
    SKU_SUCCESS,
    SKU_LOADING
} from '../actions/SKUAction';

const initialState = {    
    skuData: [],
    isLoading: true   
};

const SKU = (state = initialState, action = {}) => {

    switch (action.type) {
        case SKU_SUCCESS:
            return {
                ...state, skuData: action.data, isLoading: false
            };
        case SKU_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default SKU;
